import { useMemo } from 'react'
import { isRouteErrorResponse, Link, useRouteError } from 'react-router-dom'
import { Droplets } from 'lucide-react'

export default function InternalErrorPage() {
  const error = useRouteError()
  const requestId = useMemo(() => crypto.randomUUID().slice(0, 8).toUpperCase(), [])

  const detail = isRouteErrorResponse(error)
    ? `${error.status} ${error.statusText}`
    : error instanceof Error
      ? error.message
      : undefined

  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-gray-50">
      <div className="w-full max-w-md bg-white rounded-xl shadow-lg p-8 text-center space-y-4">
        <Droplets className="mx-auto text-hydro-600" size={40} />
        <h2 className="text-xl font-bold text-gray-900">Algo deu errado. Nossa equipe foi notificada.</h2>
        <p className="text-sm text-gray-500">
          Tente novamente em instantes. Se o problema persistir, informe o ID abaixo ao suporte.
        </p>
        <p className="text-xs font-mono text-gray-400 bg-gray-50 rounded-lg py-2 px-3">
          requestId: {requestId}
        </p>
        {detail && import.meta.env.DEV && (
          <p className="text-xs text-red-600 break-all">{detail}</p>
        )}
        <Link
          to="/dashboard"
          className="inline-block w-full py-3 bg-hydro-600 text-white rounded-lg font-medium hover:bg-hydro-700 transition-colors duration-200"
        >
          Voltar ao dashboard
        </Link>
      </div>
    </div>
  )
}
